export const PhoneFrame = ({ src, alt, className = "", testId }) => (
  <div data-testid={testId} className={`rounded-[2.2rem] bg-[#0B132B] p-[7px] shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)] ring-1 ring-white/10 ${className}`}>
    <div className="relative overflow-hidden rounded-[1.8rem] bg-black">
      <img src={src} alt={alt} loading="lazy" className="block aspect-[390/844] w-full object-cover object-top" />
      <span className="absolute left-1/2 top-2 h-[18px] w-[30%] -translate-x-1/2 rounded-full bg-black" />
    </div>
  </div>
);
